import * as React from "react";


interface TabsProps {
  value: string;
  onValueChange: (value: string) => void;
  orientation?: "vertical" | "horizontal";
  className?: string;
  children: React.ReactNode;
}

export const Tabs: React.FC<TabsProps> = ({
  value,
  onValueChange,
  orientation = "horizontal",
  className = "",
  children,
}) => {
  return (
    <div className={className} data-orientation={orientation}>
      {children}
    </div>
  );
};

interface TabsListProps {
  className?: string;
  children: React.ReactNode;
  value?: string;
  onValueChange?: (value: string) => void;
}

export const TabsList: React.FC<TabsListProps> = ({
  className = "",
  children,
  value,
  onValueChange,
}) => <div className={`rounded-md bg-muted p-1 ${className}`}>{children}</div>;

interface TabsTriggerProps {
  value: string;
  className?: string;
  children: React.ReactNode;
  tabValue?: string;
  onValueChange?: (value: string) => void;
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({
  value,
  className = "",
  children,
  tabValue,
  onValueChange,
}) => {
  const isActive = tabValue === value;
  const handleClick = () => {
    if (onValueChange) onValueChange(value);
  };
  return (
    <button
      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${
        isActive
          ? "bg-primary text-primary-foreground"
          : "text-muted-foreground hover:text-foreground"
      } ${className}`}
      data-state={isActive ? "active" : undefined}
      onClick={handleClick}
      type="button"
    >
      {children}
    </button>
  );
};

interface TabsContentProps {
  value: string;
  tabValue?: string;
  children: React.ReactNode;
}

export const TabsContent: React.FC<TabsContentProps> = ({
  value,
  tabValue,
  children,
}) => {
  if (tabValue !== value) return null;
  return <div>{children}</div>;
};

